import DoneRoundedIcon from "@mui/icons-material/DoneRounded";
import EastRoundedIcon from "@mui/icons-material/EastRounded";
import { Box, Divider, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import useAPI from "../../../../api/hooks/useAPI";
import useColors from "../../../../api/hooks/useColors"; // Adjust the import path as needed
import { DRAWER_TABS } from "../../../../utils/constants";
import NumberCircle from "./NumberCircle"; // Adjust the import path as needed
import TriageSection from "./TriageSection"; // Adjust the import path as needed

const NextStepsSection = ({
  detection,
  handleResolve,
  handleMoveToControl,
}) => {
  const colors = useColors();
  const navigate = useNavigate();
  const { trackEvent } = useAPI();
  const navigateToRemediation = () => {
    if (handleMoveToControl) {
      handleMoveToControl(DRAWER_TABS.REMEDIATION_TAB);
    } else {
      const message = "User navigated to remediation from detection tab";
      trackEvent(message).then();
      navigate("/remediation/plan?remediation=" + detection.control_id);
    }
  };
  const stepBoxStyle = {
    display: "flex",
    flexDirection: "row",
    gap: "12px",
    alignItems: "flex-start",
    justifyContent: "flex-start",
  };
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "16px",
      }}
    >
      <Divider flexItem style={{ marginTop: "10px" }} />
      <Typography variant="overline">Next Steps</Typography>

      <Box
        sx={{
          ...stepBoxStyle,
        }}
      >
        <NumberCircle number={1} />
        <TriageSection detection={detection} />
      </Box>
      <Box
        sx={{
          ...stepBoxStyle,
        }}
      >
        <NumberCircle number={2} />
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "8px",
          }}
        >
          <Typography variant="overline">If Activity is Familiar</Typography>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              gap: "8px",
              alignItems: "center",
              color: colors.primary_main,
              cursor: "pointer",
            }}
            onClick={handleResolve}
          >
            <Typography variant="overline">Resolve the Event</Typography>
            <DoneRoundedIcon sx={{ width: "18px" }} />
          </Box>
        </Box>
      </Box>
      <Box
        sx={{
          ...stepBoxStyle,
        }}
      >
        <NumberCircle number={3} />
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "8px",
          }}
        >
          <Typography variant="overline">If Activity is Unfamiliar</Typography>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              gap: "8px",
              alignItems: "center",
              color: colors.primary_main,
              cursor: "pointer",
            }}
            onClick={navigateToRemediation}
          >
            <Typography variant="overline">Go to Gap Remediation</Typography>
            <EastRoundedIcon sx={{ width: "18px" }} />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default NextStepsSection;
